export default function numberSelector() {
    return {
        restrict: "E",
        scope: {
            counter: "=",
            allowZero: "=",
            passTabindex: "=",
            maxValue: "="
        },
        replace: false,
        template: require("./template.html"),

        controller: function($scope) {
            $scope.getTabIndex = function() {
                if ($scope.passTabindex) {
                    return $scope.passTabindex;
                } else {
                    return -1;
                }
            };
            /**
             * Add 1 hour / duration
             */
            $scope.addHourToHours = function() {
                //console.log('click ADD');

                if ($scope.counter < $scope.maxValue) {
                    $scope.counter += 1;
                }
            };

            /**
             * Subtract 1 hour / duration
             */
            $scope.subtractHourFromHours = function() {
                if ($scope.allowZero) {
                    if ($scope.counter > 0) {
                        $scope.counter -= 1;
                    }
                } else {
                    if ($scope.counter > 1) {
                        $scope.counter -= 1;
                    }
                }
            };
        }
    };
}
